import { Message } from 'primeng/api';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserRegistrationService } from '../user-registration.service';
import { CognitoCallback } from '../cognito.service';

export class RegistrationUser {
    name: string;
    email: string;
    password: string;
}
/**
 * This component is responsible for displaying and controlling
 * the registration of the user.
 */
@Component({
    selector: 'app-register',
    templateUrl: './registration.component.html'
})
export class RegisterComponent implements CognitoCallback {
    registrationUser: RegistrationUser;
    router: Router;
    errorMessages: Message[];

    constructor(public userRegistration: UserRegistrationService, router: Router) {
        this.router = router;
        this.onInit();
    }

    onInit() {
        this.registrationUser = new RegistrationUser();
        this.errorMessages = [];
    }

    onRegister() {
        this.errorMessages = [];
        if (this.registrationUser.name == null || this.registrationUser.password == null || this.registrationUser.email == null) {
            this.errorMessages = [({ severity: 'error', detail: 'All fields are required' })];
            return;
        }
        this.userRegistration.register(this.registrationUser, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message != null) { // error
            this.errorMessages = [({ severity: 'error', detail: message })];
            console.log('result: ' + message);
        } else { // success
            // move to the next step
            console.log('redirecting');
            this.router.navigate(['/confirmRegistration', result.user.username]);
        }
    }
}
